export default __webpack_public_path__ + "static/media/flor.ad313ba5.mp3";